import { api } from "./api";
import { GET_COURSE_RECOMMENDATION } from "../apiEndPoints";

export const eduCentreApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getCourseRecommendation: builder.query({
      query: ({ student_id, sort, rating, subject, course }) => {
        let URL = `${GET_COURSE_RECOMMENDATION}?student_id=${student_id}`;
        if (sort) {
          URL += `&sort=${sort}`;
        }
        if (rating) {
          URL += `&rating=${rating}`;
        }
        if (subject) {
          URL += `&subject=${subject}`;
        }
        if (course) {
          URL += `&course=${course}`;
        }
        return {
          url: URL,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useGetCourseRecommendationQuery } = eduCentreApiSlice;
